import { useAnalytics } from '../../providers/AnalyticsProvider';

export const useAnalyticsProvider = useAnalytics;